import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { NavLink, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Input } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../image/dheena.png";

const drawerWidth = 220;
const navLinks = [
  { path: "/", text: "Home" },
  { path: "/PopularA", text: "Popular Movies" },
  { path: "/toprated", text: "Top Rated" },
  { path: "/nowplay", text: "Now Playing" },
];

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const trimmedSearch = search.trim();
    if (trimmedSearch) {
      navigate(`/search/${encodeURIComponent(trimmedSearch)}`);
      setSearch('');
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <Link to={"/"} onClick={handleDrawerToggle} style={{ textDecoration: "none", color: "#fff" }}>
          <img src={logo} alt="Movie DB home" height={30} width={124} />
        </Link>
      </Typography>
      <Divider />
      <List>
        {navLinks.map((link) => (
          <ListItem key={link.path} disablePadding>
            <ListItemButton
              component={NavLink}
              to={link.path}
              onClick={handleDrawerToggle}
              sx={{
                textAlign: "center",
                mx: 1,
                my: 0.5,
                borderRadius: 1.5,
                color: "#fff",
                transition: "background-color 220ms ease, color 220ms ease, transform 180ms ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                  transform: "translateX(4px)",
                },
                "&.active": {
                  backgroundColor: "#fff",
                  color: "#000",
                },
              }}
            >
              <ListItemText primary={link.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ bgcolor: 'black' }}>
        <Toolbar sx={{ px: { xs: '10px', sm: 'clamp(10px, 4vw, 100px)' } }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
              <img src={logo} alt="Movie DB home" height={30} width={'auto'} />
            </Link>
          </Typography>

          <form onSubmit={handleSearchSubmit}>
            <Input
              sx={{ color: "white", mx: 2 }}
              value={search}
              onChange={handleSearchChange}
              placeholder="Search..."
              inputProps={{
                'aria-label': 'Search for movies',
                type: 'search',
                maxLength: 100,
              }}
              endAdornment={
                <IconButton type="submit" aria-label="Submit search" sx={{ color: 'white', p: 1 }}>
                  <FontAwesomeIcon icon={faSearch} />
                </IconButton>
              }
            />
          </form>

          <Box sx={{ display: { xs: "none", sm: "flex" }, ml: 2 }}>
            {navLinks.map((link) => (
              <Button
                key={link.path}
                component={NavLink}
                to={link.path}
                disableRipple
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  mx: 0.5,
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  position: "relative",
                  fontWeight: 500,
                  transition: "color 220ms ease, background-color 220ms ease, transform 180ms ease",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                    transform: "translateY(-1px)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: "50%",
                    bottom: 4,
                    height: "2px",
                    width: 0,
                    backgroundColor: "#F6C703",
                    transition: "width 240ms ease, left 240ms ease",
                  },
                  "&:hover::after": {
                    width: "60%",
                    left: "20%",
                  },
                  "&.active": {
                    backgroundColor: "#fff",
                    color: "#000",
                  },
                  "&.active::after": {
                    width: 0,
                  },
                  "&:focus-visible": {
                    outline: "2px solid #F6C703",
                    outlineOffset: 2,
                  },
                }}
              >
                {link.text}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "black",
              color: "#fff",
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Toolbar />
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
